import React from 'react';
import {
  Typography,
  Chip,
  Card,
  CardContent,
  Link,
} from '@material-ui/core';
import { VersionCardProps } from './types';

export const VersionCard = ({ version, formatTimestamp }: VersionCardProps) => {
  const v = version;

  return (
    <Card variant="outlined" style={{
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 150,
    }}>
      <CardContent style={{
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flex: 1,
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}>
          <div>
            <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
              v{v.version}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {v.current_stage || '-'}
            </Typography>
            <div style={{ marginTop: 6 }}>
              <Typography variant="caption" color="textSecondary">
                {formatTimestamp(v.creation_timestamp)}
              </Typography>
            </div>
          </div>

          <div style={{ textAlign: 'right' }}>
            <Chip
              size="small"
              label={v.current_stage || v.status || 'N/A'}
            />
          </div>
        </div>

        <div style={{ marginTop: 8 }}>
          <Typography
            variant="body2"
            style={{
              maxHeight: 40,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {v.description || '-'}
          </Typography>
        </div>

        <div style={{
          marginTop: 8,
          display: 'flex',
          gap: 8,
          alignItems: 'center',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}>
          <div>
            {v.run_link ? (
              <Link
                href={v.run_link}
                target="_blank"
                rel="noreferrer"
                variant="body2"
                style={{ color: '#d46a27' }}
              >
                {v.run_id || v.runId || 'view run'}
              </Link>
            ) : (
              <Typography variant="body2">
                {v.run_id || v.runId || ''}
              </Typography>
            )}
          </div>

          <div style={{
            display: 'flex',
            gap: 6,
            flexWrap: 'wrap',
            maxHeight: 28,
            overflow: 'hidden',
            alignItems: 'center',
          }}>
            {(v.tags || []).slice(0, 3).map((t: any) => (
              <Chip
                key={t.key}
                size="small"
                label={`${t.key}: ${t.value}`}
                style={{
                  background: '#f5f5f5',
                  height: 24,
                  fontSize: 12,
                  borderRadius: 16,
                }}
              />
            ))}
          </div>
        </div>

        {/* Metrics section */}
        <div style={{ marginTop: 10 }}>
          <Typography variant="caption" style={{ fontWeight: 600, display: 'block', marginBottom: 4 }}>
            Metrics
          </Typography>
          {v.runInfo?.data?.metrics && v.runInfo.data.metrics.length > 0 ? (
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr auto',
              rowGap: 4,
              columnGap: 12,
              maxHeight: 100,
              overflowY: 'auto',
            }}>
              {v.runInfo.data.metrics.slice(0, 8).map((m: any) => (
                <React.Fragment key={m.key}>
                  <Typography
                    variant="caption"
                    style={{
                      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
                      color: '#555',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    title={m.key}
                  >
                    {m.key}
                  </Typography>
                  <Typography variant="caption" style={{ fontWeight: 500 }}>
                    {m.value}
                  </Typography>
                </React.Fragment>
              ))}
            </div>
          ) : (
            <Typography variant="caption" style={{ color: '#777' }}>
              No metric info available
            </Typography>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
